import alt from '../alt';
import employeeAction from '../actions/employeeAction';

class employeeStore {
    constructor() {
        this.bindActions(employeeAction);
        this.processing = false;
        this.warningMsg = "";
        this.userDetail = {comHandphone:{},comLaptop:{},comCabcard:{}};
        this.search = "";
        this.staffId = "";
        this.displayDetail = false;
        this.staffs = [];
        this.iniLoadStaff = false;
    }
    onEmployeeSuccess(data){
        this.staffs = data;
        this.iniLoadStaff = true;
    }
    onProcessing(data) {
        this.processing = data;
    }

    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onSearch(data) {
        this.search = data;
    }
    onDisplayDetail(data) {
        this.displayDetail = data;
    }
    onStaffId(data){
        this.staffId = data;
    }

    onUserDetailSuccess(data){
        this.userDetail = data;
    }
    onClear(){
        this.userDetail = {comHandphone:{},comLaptop:{},comCabcard:{}};
    }
}
export default alt.createStore(employeeStore, 'employeeStore');


// WEBPACK FOOTER //
// ./app/stores/employeeStore.js